import React, { memo, useEffect, useState } from 'react';
import { Box, Button, FormControl, Icon, InputAdornment, InputLabel, ListItemText, MenuItem, OutlinedInput, Paper, Select, TextField, Typography } from '@mui/material';

import { OnSelectionChangeParams } from 'react-flow-renderer';
import { IListagemCampanhaSimples, IListagemCanal, IListagemCondicionaisRetorno, IListagemFornecedora, listKeyValueTipoEdge } from 'shared/types';
import theme from 'shared/themes/theme';
import { stringToDateTime } from 'shared/utils';

const style: { [key: string]: React.CSSProperties } = {
  title: {
    position: 'relative',
    padding: '8px 8px',
    marginTop: '8px',
    flexGrow: 1,
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'grab',
  },
  icon: {
    marginRight: '10px',
    marginLeft: '10px'
  },
  aside: {
    borderRight: '1px solid #eee',
    padding: '15px 10px',
    fontSize: '12px !important',
    background: '#fcfcfc',
    width: '280px',
    maxHeight:  `calc(100vh - ${theme.spacing(30)})`,
    overflowY: 'scroll',
  }
};

interface componenteDetalheProps {
  nome: string;
  descricao?: string;
  tipo?: string;
  campanha?: string;
  canal?: string;
  fornecedora?: string;
  condicionalRetorno?: string[];
  textoCondicionalRetorno?: string[];
  sleep?: number;
  isEditable: boolean;
  listCampanha?: IListagemCampanhaSimples[];
  listCanais?: IListagemCanal[];
  listFornecedora?: IListagemFornecedora[];
  listCondicionaisRetorno?: IListagemCondicionaisRetorno[];
  elemento: OnSelectionChangeParams;
  handleChangeNome: (text: string) => void;
  handleChangeDescricao: (text: string) => void;
  handleChangeTipo?: (text: string) => void;
  handleChangeCampanha?: (text: string) => void;
  handleChangeCanal?: (text: string) => void;
  handleChangeFornecedora?: (text: string) => void;
  handleChangeCondicionalRetorno?: (text: string, index: number) => void;
  handleChangeTextoCondicionalRetorno?: (text: string, index: number) => void;
  handleChangeSleep?: (num: number) => void;
  handleClickAddCondicional?: () => void;
  handleClickDelCondicional?: () => void;
  handleClickAtualizar: (isNode: boolean, elmId: string) => void;
}

const ComponenteDetalhe: React.FC<componenteDetalheProps> = ({
  nome,
  descricao,
  tipo,
  elemento,
  campanha,
  canal,
  fornecedora,
  condicionalRetorno,
  textoCondicionalRetorno,
  sleep,
  isEditable,
  listCampanha,
  listCanais,
  listFornecedora,
  listCondicionaisRetorno,
  handleChangeNome,
  handleChangeDescricao,
  handleChangeTipo,
  handleChangeCampanha,
  handleChangeCanal,
  handleChangeFornecedora,
  handleChangeCondicionalRetorno,
  handleChangeTextoCondicionalRetorno,
  handleChangeSleep,
  handleClickAddCondicional,
  handleClickDelCondicional,
  handleClickAtualizar
}) => {
  const isNode = elemento.nodes.length > 0;
  const elmType = isNode ? elemento.nodes[0].type : 'Conexão';
  const elmId = isNode ? elemento.nodes[0].id : elemento.edges[0].id;
  const isCmpOnline = isNode ? elemento.nodes[0].data.cmpOnline : false;
  const [disable, setDisable] = useState(true);
  const objCampanha = campanha !== '' ? listCampanha?.filter(camp => camp.IdCampanha === Number(campanha as string)) : null;

  useEffect(() => {
    if (!isNode)
      setDisable(false);
  }, []);

  useEffect(() => {
    if (elmType === 'campanha') {
      if (campanha !== '')
        setDisable(false);
      else
        setDisable(true);
    }
    if (elmType === 'condicional') {
      if (condicionalRetorno?.toString() !== '' && condicionalRetorno?.[condicionalRetorno.length - 1] !== '')
        setDisable(false);
      else
        setDisable(true);
    }
    if (elmType === 'sleep') {
      if (sleep) {
        if (sleep >= 15)
          setDisable(false);
        else
          setDisable(true);
      }
      else
        setDisable(true);
    }
  }, [nome, descricao, campanha, condicionalRetorno, sleep]);

  return (
    <Box component="aside" style={style.aside} >
      <Box p={1} display='flex' flexDirection='column' component={Paper} >

        <Box p={1} component={Paper} >
          <Typography
            overflow="hidden"
            whiteSpace="nowrap"
            textOverflow="ellipses"
            variant={'h6'}
            align='center'
          >
            {elmType}
          </Typography>

        </Box>

        <TextField
          margin='normal'
          size='small'
          type='text'
          label='Nome'
          disabled={!isEditable}
          value={nome}
          inputProps={{ maxLength: 50 }}
          onChange={(e) => handleChangeNome(e.target.value)}
        />
        {!isNode && (
          <FormControl margin='dense' sx={{ width: '100%' }}>
            <InputLabel id={'label-select-tipo'}>Tipo</InputLabel>
            <Select
              disabled={!isEditable}
              size='small'
              labelId={'label-select-tipo'}
              input={<OutlinedInput label='Tipo' />}
              value={tipo}
              onChange={(e) => handleChangeTipo?.(e.target.value)}
            >
              <MenuItem value=''>
                <ListItemText primary='' />
              </MenuItem>
              {listKeyValueTipoEdge.map((item) => (
                <MenuItem key={item.key} value={item.key}>
                  <ListItemText  style={{overflow: 'hidden'}} primary={item.value} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {isNode && (
          <>
            <TextField
              margin='normal'
              size='small'
              type='text'
              disabled={!isEditable}
              multiline
              maxRows={2}
              minRows={2}
              label='Descrição'
              value={descricao}
              inputProps={{ maxLength: 100 }}
              onChange={(e) => handleChangeDescricao(e.target.value)}
            />
            {elmType === 'campanha' && (
              <FormControl margin='dense' sx={{ width: '100%' }}>
                <InputLabel id={'label-select-campanha'}>Campanha</InputLabel>
                <Select
                  disabled={!isEditable}
                  size='small'
                  labelId={'label-select-campanha'}
                  input={<OutlinedInput label='Campanha' />}
                  value={campanha}
                  onChange={(e) => handleChangeCampanha?.(e.target.value)}
                >
                  <MenuItem value=''>
                    <ListItemText primary='' />
                  </MenuItem>
                  {isCmpOnline ?
                    listCampanha?.filter(item => item.FlagCampanhaOnline === 'S').map((item) => (
                      <MenuItem key={item.IdCampanha} value={item.IdCampanha}>
                        <ListItemText style={{overflow: 'hidden'}} primary={`${item.IdCampanha} - ${item.NomeCampanha}`} />
                      </MenuItem>
                    ))
                    :
                    listCampanha?.filter(item => item.FlagCampanhaOnline !== 'S').map((item) => (
                      <MenuItem key={item.IdCampanha} value={item.IdCampanha}>
                        <ListItemText style={{overflow: 'hidden'}} primary={`${item.IdCampanha} - ${item.NomeCampanha}`} />
                      </MenuItem>
                    ))
                  }
                </Select>
                {campanha !== '' && objCampanha && (
                  <Box marginTop={3} style={{ border: '1px solid #222138', borderRadius: '4px' }}>
                    <Box margin={2}>
                      <Typography style={{ fontSize: '11pt' }}>Campanha: {objCampanha[0].CodigoCampanha}</Typography >
                      <Typography style={{ fontSize: '11pt' }}>Status: {objCampanha[0].StatusCampanha}</Typography >
                      <Typography style={{ fontSize: '11pt' }}>Tipo Envio: {objCampanha[0].FlagCampanhaOnline === 'S'? `Online - ${objCampanha[0].TipoCampanhaOnline === 'EXT'? 'Externo':'Interno'}`:'Massivo'}</Typography >
                      <Typography style={{ fontSize: '11pt' }}>Período</Typography >
                      <Typography marginLeft={2} style={{ fontSize: '11pt' }}>Inicio: {stringToDateTime(objCampanha[0].DataCampanhaInicio)}</Typography>
                      <Typography marginLeft={2} style={{ fontSize: '11pt' }}>Fim: {stringToDateTime(objCampanha[0].DataCampanhaTermino)}</Typography>
                      <Typography style={{ fontSize: '11pt' }}>Canal/Fornecedora</Typography>
                      {objCampanha[0].ListaCanalFornecedora.split(' , ').map((canalFornecedora) => (
                        <Typography key={canalFornecedora} marginLeft={2} style={{ fontSize: '11pt' }}> - {canalFornecedora}</Typography>
                      ))}
                    </Box>
                  </Box>
                )}
              </FormControl>
            )}
            {elmType === 'sleep' && (
              <TextField
                size='small'
                type='text'
                label='Sleep'
                disabled={!isEditable}
                value={sleep}
                onChange={(e) => { if (!Number.isNaN(Number(e.target.value))) { handleChangeSleep?.(Number(e.target.value)); } }}
                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', maxLength: 5 }}
                InputProps={{
                  endAdornment: <InputAdornment position='end'>{sleep ? sleep > 1 ? 'minutos' : 'minuto' : 'minuto'}</InputAdornment>,
                }}

              />
            )}
            {elmType === 'condicional' && (
              <>
                <FormControl margin='dense' sx={{ width: '100%' }}>
                  <InputLabel id={'label-select-condicional-canal'}>Canal</InputLabel>
                  <Select
                    disabled={!isEditable}
                    size='small'
                    labelId={'label-select-condicional-canal'}
                    input={<OutlinedInput label='Canal' />}
                    value={canal}
                    onChange={(e) => handleChangeCanal?.(e.target.value)}
                  >
                    <MenuItem value=''>
                      <ListItemText primary='' />
                    </MenuItem>
                    {listCanais?.map((item) => (
                      <MenuItem key={item.IdCanal} value={item.IdCanal}>
                        <ListItemText style={{overflow: 'hidden'}} primary={item.NomeCanal} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {(canal !== '') && (
                  <FormControl margin='dense' sx={{ width: '100%' }}>
                    <InputLabel id={'label-select-condicional-fornecedora'}>Fornecedora</InputLabel>
                    <Select
                      disabled={!isEditable}
                      size='small'
                      labelId={'label-select-condicional-fornecedora'}
                      input={<OutlinedInput label='Fornecedora' />}
                      value={fornecedora}
                      onChange={(e) => handleChangeFornecedora?.(e.target.value)}
                    >
                      <MenuItem value=''>
                        <ListItemText primary='' />
                      </MenuItem>
                      {listFornecedora?.filter((item) => item.IdCanal === Number(canal)).map((item) => (
                        <MenuItem key={item.IdFornecedora} value={item.IdFornecedora}>
                          <ListItemText style={{overflow: 'hidden'}} primary={item.NomeFornecedora} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
                {(canal !== '' && fornecedora !== '') && (
                  <>
                    {condicionalRetorno?.map((condRet, index) => (
                      <FormControl key={index} margin='normal' sx={{ width: '100%' }} >
                        <InputLabel id={'label-select-condicional-retorno'}>Condicional Retorno</InputLabel>
                        <Select
                          disabled={!isEditable}
                          size='small'
                          labelId={'label-select-condicional-retorno'}
                          input={<OutlinedInput label='Condicional Retorno' />}
                          value={condRet}
                          onChange={(e) => handleChangeCondicionalRetorno?.(e.target.value, index)}
                        >
                          <MenuItem value=''>
                            <ListItemText primary='' />
                          </MenuItem>
                          {listCondicionaisRetorno?.filter((item) => item.IdCanal === Number(canal) && item.IdFornecedora === Number(fornecedora) &&
                            (item.TamanhoCondicionalRetorno > 0 || (item.TamanhoCondicionalRetorno === 0 && (condicionalRetorno?.indexOf(item.IdCondicionalRetorno.toString()) >= index
                              || condicionalRetorno?.indexOf(item.IdCondicionalRetorno.toString()) === -1)))).map((item) => (
                            <MenuItem key={item.IdCondicionalRetorno} value={item.IdCondicionalRetorno}>
                              <ListItemText style={{overflow: 'hidden'}} primary={`${item.NomeCondicionalRetorno} - ${item.DescricaoCondicionalRetorno}`} />
                            </MenuItem>
                          ))
                          }
                        </Select>
                        {condRet !== '' && listCondicionaisRetorno?.filter((item) => item.IdCanal === Number(canal) && item.IdFornecedora === Number(fornecedora) && item.IdCondicionalRetorno === Number(condRet)).map((item) => (
                          item.TamanhoCondicionalRetorno > 0 && (
                            <TextField
                              key={item.IdCondicionalRetorno}
                              margin='dense'
                              size='small'
                              type='text'
                              label={item.TipoCondicionalRetorno === 'NOINTERACT'?'Tempo de espera em horas':`Texto Resposta ${item.NomeCondicionalRetorno}`}
                              disabled={!isEditable}
                              value={textoCondicionalRetorno?textoCondicionalRetorno[index]:''}
                              onChange={(e) => { 
                                if(item.TipoCondicionalRetorno === 'NOINTERACT')
                                { 
                                  if (!Number.isNaN(Number(e.target.value))) 
                                  { 
                                    handleChangeTextoCondicionalRetorno?.(e.target.value, index);
                                  }
                                }
                                else
                                {
                                  handleChangeTextoCondicionalRetorno?.(e.target.value.toUpperCase(), index); 
                                }
                              }}
                              inputProps={{maxLength: item.TamanhoCondicionalRetorno }}
                            />
                          )
                        ))
                        }
                      </FormControl>

                    ))}
                    <Box display="flex" p={4} >
                      <Button
                        color='primary'
                        disableElevation
                        disabled={(condicionalRetorno?.[condicionalRetorno?.length - 1] === '') || !isEditable}
                        variant='outlined'
                        onClick={handleClickAddCondicional}
                        startIcon={<Icon>add</Icon>}
                        sx={{ marginX: theme.spacing(1), width: '100%' }}
                      >
                        <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden" >
                          CR
                        </Typography>
                      </Button>
                      <Button
                        color='primary'
                        disableElevation
                        disabled={condicionalRetorno?.length === 1 || !isEditable}
                        variant='outlined'
                        onClick={handleClickDelCondicional}
                        startIcon={<Icon>remove</Icon>}
                        sx={{ marginX: theme.spacing(1), width: '100%' }}
                      >
                        <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden" >
                          CR
                        </Typography>
                      </Button>
                    </Box>
                  </>
                )}
              </>
            )}
          </>)}
        <Box display="flex" p={4} >
          <Button
            color='primary'
            disableElevation
            variant='outlined'
            disabled={disable || !isEditable}
            onClick={() => handleClickAtualizar(isNode, elmId)}
            startIcon={<Icon>check</Icon>}
          >
            <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden" >
              Atualizar
            </Typography>
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default memo(ComponenteDetalhe);